// Is this URL the kiosk?
//
// Pure and separate from `KioskApp` so `main.tsx` can ask the question without
// importing the kiosk's stylesheet — and so a test can pin the answer without a
// browser. The wrong answer in either direction is bad in a different way: a
// false positive puts a guest surface in front of the front desk, and a false
// negative puts the front desk's tape chart in a hotel lobby.
//
// The match is on the path SEGMENT, not a prefix. `startsWith('/kiosk')` says
// yes to `/kiosks-report` and to any future `/kiosk-admin`, which is the kind
// of thing nobody notices until the day somebody adds that route.

/** True for `/kiosk` and anything under it — `/kiosk/`, `/kiosk/check-in`.
 *  A kiosk browser is pointed at one URL and left there, so sub-paths cost
 *  nothing to allow and save an argument later. */
export function isKioskURL(pathname: string): boolean {
  const clean = pathname.replace(/\/+$/, '')
  return clean === '/kiosk' || clean.startsWith('/kiosk/')
}
